import UIShareManager from './UIShareManager';

export default UIShareManager;
